var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgReplyRate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: "512px",
    viewBox: "0 0 24 24",
    width: "512px",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.25 22c-.27 0-.524-.146-.658-.391l-.021-.038c-2.243-4.051-6.517-6.571-11.153-6.571h-1.418v4.25c0 .301-.181.573-.458.691-.275.116-.599.058-.814-.153l-8.5-8.25c-.146-.141-.228-.335-.228-.538s.082-.397.228-.538l8.5-8.25c.216-.21.539-.27.814-.153.277.118.458.39.458.691v4.252c7.743.134 14 6.474 14 14.248 0 .343-.232.642-.564.727-.062.016-.124.023-.186.023zm-14-8.5h2.168c4.176 0 8.089 1.829 10.764 4.911-1.294-5.669-6.377-9.911-12.432-9.911h-.5c-.414 0-.75-.336-.75-.75v-3.227l-6.673 6.477 6.673 6.477v-3.227c0-.414.336-.75.75-.75z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#535353"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReplyRate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/replyRate.7827e7cc.svg";
export { ForwardRef as ReactComponent };